<template>
  <div class="payment">
    <div class="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/navigator/personal/info' }">个人中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/navigator/personal/info/orders' }">订单管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/navigator/personal/orderDetail?orderType=${orderType}&orderId=${orderId}` }">订单详情</el-breadcrumb-item>
        <el-breadcrumb-item>支付</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <div class="title">支付金额: &nbsp;{{ price | PriceFilter }} 元</div>
      <div class="title">支付方式:&nbsp;
        <el-radio-group v-model="radio1">
          <el-radio-button label="1">
            <img src='../../../assets/font/weixin.png'>微信支付
          </el-radio-button>
          <el-radio-button label="2" v-show="monthlyMarker == 1">
            <i class="el-icon-date"></i>月 结
          </el-radio-button>
        </el-radio-group>
      </div>
      <div class="title price" v-show="radio1 == 1">发票信息:&nbsp;
        <span>{{invoice}} <span @click="dialogVisible = true">修改</span></span>
      </div>
      <br/>
      <div class="btn">
        <el-button type="primary" @click="onSubmit"><div>&nbsp;支&nbsp;&nbsp;付&nbsp;</div></el-button>
        <p>拒绝支付，<span @click="$router.push({ path: `/navigator/property/${commonService.complaint}` })">我要投诉</span></p>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="700px" top="10vh">
      <div class="invoiceList">
        <el-radio-group v-model="radio2">
          <el-radio class="invoice-radio invoice-noneed" :label="1">
            <strong>无需发票</strong>
          </el-radio>
          <el-radio class="invoice-radio" v-for="(item, index) in invoice_list" :key="index" :label="`${item.invoiceId}/${item.invoiceType}/${item.invoiceTitle}`">
            <strong>{{item.invoiceType===2?'增值税发票':'普通发票'}}</strong>
            <el-row :gutter="24">
              <el-col :span="5"><div class="grid-content bg-purple" style="float: right"><em>发票抬头</em>：</div></el-col>
              <el-col :span="19"><div class="grid-content bg-purple invoice-title">{{item.invoiceTitle}}</div></el-col>
            </el-row>
            <el-row :gutter="24" v-if="item.invoiceType===1 && item.type ===1">
              <el-col :span="5"><div class="grid-content bg-purple" style="float: right"><em>纳税人识别号</em>：</div></el-col>
              <el-col :span="19"><div class="grid-content bg-purple invoice-title">{{item.creditCode}}</div></el-col>
            </el-row>
            <el-row :gutter="24" v-if="item.invoiceType===2">
              <el-col :span="5"><div class="grid-content bg-purple" style="float: right"><em>注册电话</em>：</div></el-col>
              <el-col :span="19"><div class="grid-content bg-purple invoice-title">{{item.registerTel}}</div></el-col>
            </el-row>
            <el-row :gutter="24" v-if="item.invoiceType===2">
              <el-col :span="5"><div class="grid-content bg-purple" style="float: right"><em>注册地址</em>：</div></el-col>
              <el-col :span="19"><div class="grid-content bg-purple invoice-title">{{item.registerAddress}}</div></el-col>
            </el-row>
            <el-row :gutter="24" v-if="item.invoiceType===2">
              <el-col :span="5"><div class="grid-content bg-purple" style="float: right"><em>银行账号</em>：</div></el-col>
              <el-col :span="19"><div class="grid-content bg-purple invoice-title">{{item.bankAccount}}</div></el-col>
            </el-row>
            <el-row :gutter="24" v-if="item.invoiceType===2">
              <el-col :span="5"><div class="grid-content bg-purple" style="float: right"><em>开户银行</em>：</div></el-col>
              <el-col :span="19"><div class="grid-content bg-purple invoice-title">{{item.bankName}}</div></el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="5"><div class="grid-content bg-purple" style="float: right"><em>收票人手机</em>：</div></el-col>
              <el-col :span="19"><div class="grid-content bg-purple">{{!item.receiverMobile ? '--' : item.receiverMobile}}</div></el-col>
            </el-row>
          </el-radio>
        </el-radio-group>
      </div>
      <div class="main-pagination invoice-page" v-if="totalPage > pageRows">
        <el-pagination background layout="prev,pager,next" :total="totalPage" @current-change="handlePageChange" :page-size="pageRows"></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" plain @click="$router.push({ path:`/navigator/personal/info/invoice`})">添加发票信息 +</el-button>
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="onConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>+

<script>
import { mapGetters } from 'vuex';
import { jsTimestampFilter } from '@/utils/filters.js'
import commonService from '@/static/commonService';

export default {
  data() {
    return {
      commonService: {},
      totalPage: 0,
      invoice_list: [],
      payInfo: {
        address: '深圳南山',
        bookingdate: '2018-03-17',
        codeUrl: '',
        payCloseTime: 0,
      },
      price: 0,
      monthlyMarker: 0,
      pageIndex: 1,
      invoice: '无需发票',
      radio1: '1',
      radio2: 1,
      dialogVisible: false,
      pageRows: 5,
      meetingRoom: {},
      loading: false,
      submitSuccessFlag: false,
      tipsMsg: '',
      startTime: new Date(),
      timeInterval: null,
      payStatusInterval: null,
      invoiceMarker: 2,
      invoiceId: 0,
      orderType: 0,
      orderId: 0,
    }
  },
  computed: {
    ...mapGetters(['currentParkId', 'token']),
    time() {
      var endTime = this.payInfo.payCloseTime;
      var t = endTime - this.startTime.getTime();
      var hour =  Math.floor(t / 1000 / 3600);
      var min = Math.floor((t - hour * 3600 * 1000)  / 1000 / 60);
      var sec = Math.floor((t - hour * 3600 * 1000 - min * 60 * 1000) / 1000 );
      if (hour < 10) {
        hour = '0' + hour;
      }
      if (min < 10) {
        min = '0' + min;
      }
      if (sec < 10) {
        sec = '0' + sec;
      }
      // const countDownTime = hour + ':' + min + ':' + sec;
      const countDownTime = hour > 0 ? `${hour}时${min}分${sec}秒` : `${min}分${sec}秒`;
      return countDownTime;
    },
  },
  created() {
    this.commonService = commonService[process.env.commonServiceConfKey][this.currentParkId];
  },
  mounted() {
    this.price = this.$route.query.price
    this.orderType = this.$route.query.orderType
    this.orderId = this.$route.query.orderId
    this.monthlyMarker = this.$route.query.monthlyMarker
    this.getList();
    // this.payStatusInterval = setInterval(() => {
    //   this.payStatus();
    // }, 5000);
  },
  methods: {
    onConfirm(){
      this.dialogVisible = false;
      this.invoice = this.radio2 === 1 ? "无需发票" : this.radio2.toString().split('/')[1] == 2 ? `增值税发票/${this.radio2.toString().split('/')[2]}`:`普通发票/${this.radio2.toString().split('/')[2]}`
      this.invoiceId = this.radio2 ==1 ? 0 : this.radio2.toString().split('/')[0];
    },
    handlePageChange(e){
      this.pageIndex = e;
      this.getList();
    },
    getList(){
      this.$http.post(`${this.URL_PREFIX}/app/get/user/invoice/info/list`,{
        currPage: this.pageIndex,
        pageRows: this.pageRows,
      },{
        headers: { token: this.token },
      }).then((res) => {
        if(res.data.resCode == 10000){
          this.totalPage = res.data.resData.pageInfo.total;
          this.invoice_list = res.data.resData.pageList;
        }else{
          alert(res.data.resDesc);
        }
      })
    },
    stopTime() {
      clearInterval(this.timeInterval);
      clearInterval(this.payStatusInterval);
      this.timeInterval = null;
    },
    onSubmit() {  // 获取支付详情
      if(this.radio1 == 1){
        this.$router.push({ path:`/navigator/pay/paySuccess?orderType=${this.orderType}&orderId=${this.orderId}&invoiceId=${this.invoiceId}&price=${this.price}`})
      }else if(this.radio1 == 2){
        this.$http.post(`${this.URL_PREFIX}/app/pay/user/order/info`,{
          paymentId: 2,
          orderId: this.orderId,
          invoiceMarker: 1,//月结无需发票
        },{
          headers: { token: this.token },
        }).then((res) => {
          if(res.data.resCode == 10000){
            this.$router.push({ path:`/navigator/personal/orderDetail?orderType=${this.orderType}&orderId=${this.orderId}`})
          }else{
            alert(res.data.resDesc);
          }
        })
      }
    },
    payStatus() {  // 获取支付状态
      const orderBody = {
        paymentId: 1,
        wxTradeType: 1,
      }
      if (this.$route.query.isBInd) {
        orderBody.bindSN = this.$route.params.orderid;
      } else {
        orderBody.orderId = this.$route.params.orderid;
      }
      this.$http.post(`${this.URL_PREFIX}/app/get/user/order/info/pay`, orderBody,
      {
        headers: { token: this.token, },
      })
      .then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.$router.push({ path: '/navigator/pay/paySuccess' });
        } else if (res.resCode === '13801' || res.resCode === '13802' || res.resCode === '13803' || res.resCode === '10004'){
          this.submitSuccessFlag = true;
          this.tipsMsg = res.resDesc;
          // setTimeout(() => {
          //   this.$router.push({ path: '/index' });
          // }, 1500);
        }
      });
    },
    // payInfo() {  // 获取支付状态
    //   const orderBody = {};
    //   if (this.$route.query.isBInd) {
    //     orderBody.bindSN = this.orderId;
    //   } else {
    //     orderBody.orderId = this.orderId;
    //   }
    //   this.$http.post(`${this.URL_PREFIX}/app/get/user/order/info/pay`, orderBody)
    //   .then((response) => {
    //     const res = response.data;
    //     console.log(res);
    //     if (res.resCode === '10000') {
    //       // this.payInfo = res.resData.pageList ? res.resData.pageList : [];
    //       // this.router.push({ path: '' })
    //     } else {

    //     }
    //   });
    // },
  },
  beforeDestroy() {
    this.stopTime();
  }
}
</script>


<style lang="scss" scoped>
.payment{
  padding: 20px 0;
  .el-icon-date{
    color: #4d90fe;
  }
  .btn{
    padding-top: 20px;
    padding-left: 7%;
    div{
      padding-left: 18px;
      padding-right: 18px;
    }
    p{
      padding-top: 24px;
      font-size: 16px;
      span{
        color: #4d90fe;
        padding-left: 8px;
        cursor: pointer;
      }
    }
  }
  .content{
    background-color: #fff;
    padding: 40px;
    padding-top: 10px;
    .price{
      height: 20px;
      span{
        color: #000;
        font-size: 16px;
        font-weight: 400;
        span{
          padding-left: 140px;
          font-size: 16px;
          color: #4d90fe;
          cursor: pointer;
        }
      }
    }
    img{
      margin-top: -1px;
      width: 16px !important;
      height: 16px;
      padding-right: 5px;
    }
    i{
      font-size:16px;
      padding-top: 13px;
      padding-left: 16px;
      padding-right: 4px;
      color: #4A90E2;
    }
    .title{
      max-width: 1100px;
      margin-top: 22px;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      font-weight: 600;
      p{
        font-weight: 500;
        font-size: 14px;
        span{
          color: #4d90fe;
          font-size: 14px;
        }
        span:hover{
          cursor: pointer;
        }
      }
    }
  }
  .invoiceList{
    height: 400px;
    overflow-y: scroll;
  }
  .invoice-radio{
    -moz-box-shadow:2px 2px 5px #ddd;
    -webkit-box-shadow:2px 2px 5px #ddd;
    box-shadow:2px 2px 5px #ddd;
    margin-top: 20px;
    width: 600px;
    .invoice-title{
      white-space: pre-wrap;
    }
  }
  .invoice-noneed{
    margin-left: 30px;
    line-height: 40px;
    vertical-align: center;
  }
  .invoice-page{
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/navigator/pay/PaymentPage.vue